<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <div class="instruction_title gpskin-title ql-editor p-0" v-html="question.formattedTitle"></div>
      <div class="instruction_info ql-editor p-0 mt-18 gpskin-content" v-html="question.formattedInformation"></div>
      <div class="mt-15">
        <div>
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="pt-41">
      <div class>
        Step Title
      </div>
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mb-30 text-left" v-model="question.formattedTitle" :options="editorOptionForQuestion" v-on:input="characterLimitValidation(question.formattedTitle, charLimit80)"></quill-editor>
    </div>

    <!-- help content -->
    <div v-if="isAddHelpEnabled" class="pt-5">
      <h5 class="answer help">Help</h5>
      <quill-editor class="bg-white mb-28" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>

    <div class="pt-14">
      <div class>
        Content
        <span class="gp-help-text fs-10 ml-15">Recommended character limit is 500. If you go beyond 750 characters, you might experience formatting issues.</span>
      </div>
      <quill-editor id="quillImage" class="instruction-screen bg-white mb-11 text-center" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption" @focus="onEditorFocus" @ready="onEditorReady($event)"></quill-editor>
      <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
        <div class="col-md-11 p-0">
          <h5 class="mt-10">Message</h5>
          <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
        </div>
        <div class="col-md-1 p-0">
          <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
            <img src="static/img/delete.svg" />
          </button>
        </div>
      </div>
    </div>

    <!-- Model Start -->
    <image-upload-model id="imageUploadSurvey" :question-sequence="question.sequence" :activity-details="activityDetails" @insertedImage="insertImage" :removeMaxDimensions="removeMaxDimensions" />
    <!-- Model End -->

    <!-- Title Image Upload -->
    <image-upload-model id="titleImageUpload" :question-sequence="question.sequence" :activity-details="activityDetails" @insertedImage="insertTitleImage" :removeMaxDimensions="removeMaxDimensions" />
    <div class="row pt-20">
      <div class="pb-10">Image:</div>
      <div class="row">
        <div
          class="
            col-xs-12 col-sm-2 col-md-2 col-lg-2
            pl-0
            pr-20
            image-box-margin
          "
        >
          <div class="row">
            <img v-if="question.imageUrl" class="img_size" :src="question.imageUrl" />
            <span v-else class="text-center img-placeholder-2">
              Accepted formats: <br />
              .png .jpeg
            </span>
          </div>
          <div class="row">
            <div class="file_container1">
              <label class="file_container_text_skin" for="file_upload">Upload Image</label>
              <a class="color_red cursor_pointer fs-15 mt-10 d-inline-block" v-if="question.imageUrl" @click="deleteImageUrl">
                <i class="fa fa-trash fs-18" aria-hidden="true"></i>
              </a>
              <input ref="fileInput" type="file" class="form-control-file" id="file_upload" accept="image/jpeg,image/png" @change="onImageUpload" />
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 p-0">
          <span class="pt-10 display-block color_898989">
            <ul>
              <li>Accepted formats: .png; .jpeg</li>
              <li>Min dimensions: 1080px x 1080px</li>
              <li>
                Large images will automatically resize to fit the width of the phone
              </li>
              <li>Image will automatically center</li>
              <li>Image will be placed below step content</li>
              <li>Only one image can be uploaded</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
    <div class="col-md-12 pb-80">
      <h5 class="score_text">Score</h5>
      <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model="question.score"> <input v-model.number="question.score" type="number" class="integer-plus-minus-input"/></integer-plusminus>
    </div>
    <activity-video-upload-modal ref="activityVideoUploadModal" @insertVideo="insertVideoInEditor" :question="question" :moduleName="onActivityModuleName" />
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import ImageUploadModel from "./image-upload-model";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import QlVideoUploadService from "@/services/ql-video-upload";
import localStorage from "@/services/localStorage";
import { Quill } from "vue-quill-editor";
import ActivityVideoUploadModal from "@/components/common/activity-video-upload-modal";
import { quillEditor } from "vue-quill-editor";
import $ from "jquery";

const MODULE_NAME = "activity";
export default {
  name: "ActivityStepGPSkin",

  mixins: [activityStepCustomMessage],

  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    editorOptionForHelp: {
      type: Object
    },
    removeMaxDimensions: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityVideoUploadModal,
    IntegerPlusminus,
    ImageUploadModel,
    quillEditor
  },
  data() {
    return {
      instructionInfo: false,
      editorOptionForQuestion: {
        placeholder: "Enter step title to describe the data collected (body part) which is used for export purposes.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOptionForimageCaptureTitle: {
        placeholder: "Enter Title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: {
            container: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], ["localVideoUpload"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]],
            handlers: {
              localVideoUpload: this.customVideoButtonHandler
            }
          }
        }
      },
      isAddHelpEnabled: false,
      editorFocused: null,
      onActivityModuleName: MODULE_NAME,
      charLimit80: 80,
      videoProgress: {
        show: false,
        percent: 0,
        max: 100
      }
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.init();
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    const VideoBlot = require("@/utils/quill-video-tag-blot");
    Quill.register(VideoBlot);
    this.$nextTick(() => {
      // The whole view is rendered, so I can safely access or query
      this.initLocalVideoUploadButton(); // initialize the audio icon so that it can be displayed
    });
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    if (!this.question.formattedInformation) {
      this.question.formattedInformation = "<p>Click the button once to begin first scan. Quickly place the device on your skin in the position shown below.<br />Click and Stick!</p>";
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
        this.$set(this.question, "formattedTitle", "");
        this.$set(this.question, "formattedInformation", "");
      } else {
        this.$set(this.question, "score", this.question.score);
        this.$set(this.question, "formattedTitle", this.question.formattedTitle);
        this.$set(this.question, "formattedInformation", this.question.formattedInformation);
      }
    },
    uploadOrignalVideo() {
      $("#videoUploadOrignal").click();
    },
    insertImage(imageData) {
      this.question.imageUrl = imageData.popupImageUrl;
      this.question.imageId = imageData.popupImageId;
      const title = this.question.formattedTitle;

      this.$nextTick(() => {
        if (this.question.formattedInformation.indexOf("<img src") >= 0) {
          this.question.formattedInformation = this.question.formattedInformation.replace(/<img[^>]*src=\"?([^\"]*)\"?([^>]*alt=\"?([^\"]*)\"?)?[^>]*>/g, `<img src="${this.question.imageUrl}" />`);
        } else {
          this.question.formattedInformation += '<img src="' + this.question.imageUrl + '"/>';
        }
        this.question.formattedTitle = " ";
        this.question.formattedTitle = title;
      });
    },

    insertTitleImage(imageData) {
      this.question.titleImageUrl = imageData.popupImageUrl;

      this.$nextTick(() => {
        if (this.question.formattedTitle.indexOf("<img src") >= 0) {
          this.question.formattedTitle = this.question.formattedTitle.replace(/<img[^>]*src=\"?([^\"]*)\"?([^>]*alt=\"?([^\"]*)\"?)?[^>]*>/g, `<img src="${this.question.titleImageUrl}" />`);
        } else {
          this.question.formattedTitle += '<img src="' + this.question.titleImageUrl + '"/>';
        }
      });
    },

    insertVideo() {
      const elem = this.$refs.videoCancel;
      elem.click();
      this.question.formattedInformation = this.question.formattedInformation + '<p><iframe class="ql-video ql-indent-8" allowfullscreen="true" src="' + this.question.popupVideoUrl + '" frameborder="0"></iframe></p>';
      this.question.popupVideoUrl = "";
      this.question.popupVideoId = "";
      window.$('#videoUploadOrignal[type="file"]').val(null);
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    characterLimitValidation(dataOld, maxCount = 80) {
      let data = dataOld;
      //Strip HTML tags
      data = this.stripHtml(data);
      if (data.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      const ftitle = this.stripHtml(question.formattedTitle);

      if (ftitle === "") {
        //Validate Title
        errorObj.msg = "Step Title is required.";
        errorObj.isValid = false;
        return errorObj;
      }

      if (ftitle.length > 80) {
        errorObj.isValid = false;
        errorObj.msg = `Step Title cannot exceed 80 limit`;
        return errorObj;
      }

      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      return errorObj;
    },
    onDropVideo(e) {
      e.stopPropagation();
      e.preventDefault();
      this.videoProgress.show = true;
      this.videoProgressPercent();
      const self = this;
      const files = e.dataTransfer.files;
      const selectedImage = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: files[0].name,
          contentType: files[0].type,
          sequence: this.question.sequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.videoActivityUploadFact(this.activityDetails.id, file).then(
          response => {
            this.videoProgress.percent = 100;
            if (response.data.result.videoUrl) {
              self.question.popupVideoUrl = response.data.result.videoUrl;
              self.question.popupVideoId = response.data.result.videoId;
            }
            window.$('#videoUploadOrignal[type="file"]').val(null);
            setTimeout(() => {
              this.videoProgress.show = false;
            }, 500);
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the video.";
            this.$toastr.error(self.errorMsg);
            self.question.popupVideoUrl = "";
            self.question.popupVideoId = "";
            window.$('#videoUploadOrignal[type="file"]').val(null);
            setTimeout(() => {
              this.videoProgress.show = false;
            }, 500);
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    onVideoChange() {
      this.videoProgress.show = true;
      this.videoProgressPercent();
      const self = this;
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById("videoUploadOrignal");
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: this.question.sequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.videoActivityUploadFact(this.activityDetails.id, file).then(
          response => {
            this.videoProgress.percent = 100;
            if (response.data.result.videoUrl) {
              self.question.popupVideoUrl = response.data.result.videoUrl;
              self.question.popupVideoId = response.data.result.videoId;
            }
            window.$('#videoUploadOrignal[type="file"]').val(null);
            setTimeout(() => {
              this.videoProgress.show = false;
            }, 500);
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the video.";
            this.$toastr.error(self.errorMsg);
            self.question.popupVideoUrl = "";
            self.question.popupVideoId = "";
            window.$('#videoUploadOrignal[type="file"]').val(null);
            setTimeout(() => {
              this.videoProgress.show = false;
            }, 500);
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    videoProgressPercent() {
      setInterval(() => {
        if (this.videoProgress.percent >= this.videoProgress.max) {
          return;
        }
        this.videoProgress.percent++;
      }, 100);
    },
    async onImageUpload(event) {
      const activityId = this.activityDetails.id;
      const self = this;
      const selectedImage = event.target.files[0];
      const validImage = await this.validateImage(selectedImage);

      if (!validImage) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(selectedImage);
      reader.onload = e => {
        const file = {
          fileName: selectedImage.name,
          contentType: selectedImage.type,
          sequence: this.question.sequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(activityId, file).then(
          response => {
            if (response.data.result.imageUrl) {
              self.question.imageUrl = response.data.result.imageUrl;
              self.question.imageId = response.data.result.imageId;
            }
            this.$toastr.success("Image uploaded successfully");
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            self.question.imageUrl = "";
            self.question.imageId = "";
          }
        );
      };
    },
    customVideoButtonHandler(val) {
      if (this.question && this.question.type && this.question.type === "GPSkin") {
        this.editorFocused = this.$refs["privacyPolicyEditor"].quill;
      }
      if (val && this.editorFocused) {
        this.$refs.activityVideoUploadModal.show();
      }
    },
    insertVideoInEditor(data) {
      const length = this.editorFocused.getSelection() ? this.editorFocused.getSelection().index : this.editorFocused.selection.savedRange.index;
      this.editorFocused.insertEmbed(length, "uploadedVideo", data);
      this.editorFocused.setSelection(length + 1);
    },
    initLocalVideoUploadButton() {
      // initialize "custom upload" button style
      this.$nextTick(() => {
        const videoButton = document.querySelector(".ql-localVideoUpload"); // "QL -" is the prefix automatically added by the plug-in
        if (videoButton) {
          //Add a style and initialize the style of the icon with fontawesome
          videoButton.classList.add("fa");
          videoButton.classList.add("fa-video-camera");
          videoButton.style.cssText = "color: #999; padding: 6px";
        }
      });
    },
    onEditorReady(editor) {
      this.editorFocused = editor;
    },
    onEditorFocus(quill) {
      this.editorFocused = quill;
    },

    async validateImage(image) {
      const isValid = image && image.name && image.name.match(/.(png|jpg|jpeg)$/i);
      if (!isValid) {
        return false;
      }
      let hasValidDimension = false;

      try {
        hasValidDimension = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onload = event => {
            const img = new Image();
            img.onload = () => {
              if (img.width >= 1080 && img.height >= 1080) {
                resolve(true);
              }
              reject(false);
            };
            img.src = event.target.result;
          };
        });
      } catch (error) {
        hasValidDimension = false;
      }

      return isValid && hasValidDimension;
    },
    deleteImageUrl() {
      this.question.imageUrl = "";
      this.question.imageId = "";
      this.$refs.fileInput.value = null;
      this.$toastr.success("Image deleted successfully");
    }
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
}
.dummy-list-content {
  width: 100%;
  height: 40px;
  padding: 9px 6px 7px;
  border-radius: 3px;
  border: solid 2px #c5d1d6;
  background: white;
  color: #4c8ce4;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 110px;
  max-height: 110px;
  padding: 5px;
}

.add-help-text {
  right: 492.5px;
  top: -38px;
  padding: 12px 13px;
}
.progress-modal {
  padding-top: 135px;
  padding-left: 170px;
  border-radius: 100%;
  display: none !important;
}
h5.help {
  top: 8px !important;
}
.score_text,
.score_input {
  left: 0 !important;
}
.video-progress-bar {
  border-radius: 50px;
}

.step-content-video-icon {
  position: absolute;
  z-index: 9;
  right: 549px;
  top: -38px;
  padding: 6.1px 13px;
  background-color: #d3dee3;
  font-size: 20px;
  color: #666669;
  opacity: 0.7;
  font-weight: normal;
  line-height: 1.27;
  cursor: pointer;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.step-content-pictur-icon {
  position: absolute;
  z-index: 9;
  right: 492.5px;
  top: -38px;
  padding: 6.1px 13px;
  background-color: #d3dee3;
  font-size: 20px;
  color: #666669;
  opacity: 0.7;
  font-weight: normal;
  line-height: 1.27;
  cursor: pointer;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;

  &.title-icon {
    right: 572.5px;
  }

  &.right-position {
    right: 596px;
  }
}

/deep/ .instruction-screen {
  .ql-container {
    .ql-editor {
      text-align: left;
    }
    .ql-editor[data-placeholder] {
      &.ql-blank {
        text-align: left;
      }
    }
  }
}

/deep/ .gpskin-content {
  img {
    margin: 22px auto;
    width: 104px;
  }
}

/deep/ .quill-editor {
  &.text-left {
    img {
      margin-left: 0;
    }
  }
}

/deep/ .gpskin-title {
  img {
    max-width: 104px;
    display: block;
    margin-top: 8px;
  }
}
.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.modal-dialog {
  display: inline-block;
  vertical-align: middle;
}

.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}

.img-placeholder-2 {
  background: #fff;
  border: 2px dashed #d3dee3;
  display: block;
  padding: 38px 5px;
  color: 666669;
  opacity: 0.7;
  font-size: 12px;
  border-radius: 3px;
}

.file_container_text_skin {
  width: auto;
  height: 33px;
  margin: 4px 10px 11px -2px;
  padding: 3px 20px 3px;
  border-radius: 3px;
  border: solid 2px #c5d1d6;
  text-align: center;
  color: #4c8ce4;
  font-family: Roboto-Regular;
  font-size: 12px;
}

.delete-image {
  position: absolute;
  top: 190px;
  right: 20px;
}
</style>
